export default "__VITE_ASSET__D4ayDmA9__";